import { render, staticRenderFns } from "./preguntas-frecuentes.vue?vue&type=template&id=1aa2b696&scoped=true"
import script from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
export * from "./preguntas-frecuentes.vue?vue&type=script&lang=js"
import style0 from "./preguntas-frecuentes.vue?vue&type=style&index=0&id=1aa2b696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2b696",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default,Accordion: require('/builds/marketing/abstracta.academy-website/components/Accordion.vue').default})
